module.exports = __webpack_public_path__ + "img/katarina9.fe56b5e5.jpg";